(function () {
  function initFreeGift() {
    const optionRadios = document.querySelectorAll(".gift-input__field");
    const addFreeGiftButtons = document.querySelectorAll(".add-free_gift");
    optionRadios.forEach((optionRadio) => optionRadio.addEventListener("change", handleVariantChange.bind(this), true));
    addFreeGiftButtons.forEach((addFreeGiftButton) => addFreeGiftButton.addEventListener("click", handleAddFreeGift.bind(this), true));

    function handleVariantChange(event) {
      const currentValue = event.currentTarget.value;
      const optionWrapper = event.currentTarget.closest(".free-gift-options_wrapper");
      const optionSelector = optionWrapper.querySelector(".option-selector");
      optionSelector.value = currentValue;
      optionSelector.querySelectorAll("option").forEach((option) => option.value == currentValue ? option.setAttribute("selected", true) : option.removeAttribute("selected"));
      updateMainSelector(event.currentTarget);
    }

    function updateMainSelector(input) {
      const optionsWrapper = input.closest(".cart-gift-option-cover");
      const optionSelectors = Array.from(optionsWrapper.querySelectorAll(".option-selector"));
      const selectedVariant = optionSelectors.map((optionSelector) => optionSelector.value).join(" / ");
      const mainVariantSelector = optionsWrapper.querySelector(".free-gift-variant-selector");
      mainVariantSelector.value = selectedVariant;
      mainVariantSelector.querySelectorAll("option").forEach((option) => option.getAttribute("data-title") == selectedVariant ? option.setAttribute("selected", true) : option.removeAttribute("selected"));
    }

    async function getCartJson() {
      return await fetch(`${window.Shopify.routes.root}cart.json`, { method: 'GET' }).then((res) => res.json());
    }

    async function handleAddFreeGift(event) {
      const mainVariantSelector = event.currentTarget.closest(".cart-gift-option-cover").querySelector(".free-gift-variant-selector");
      const freeGiftVariantId = mainVariantSelector.value;
      let addFormData = { 'items': [{ 'id': freeGiftVariantId, 'quantity': 1 }] };
      fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', }, body: JSON.stringify(addFormData) })
        .then(response => (Promise.all([response, fetch(`${window.Shopify.routes.root}cart.js`, { method: 'GET' })])))
        .then(([res1, res2]) => Promise.all([res1.json(), res2.json()]))
        .then(([response1, cart]) => {
          if (response1.status) {
            console.error("Product cannot be added", response1);
            return;
          }
          if(window.location.pathname === "/cart"){
            window.location.reload();
          }else{
            window.wetheme.drawer.updateCartDrawer(cart);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    async function freeGiftCheckOnCartPage(){
      const cart = await getCartJson();
      const totalItemsInCart = cart.items.length;
      let isFreeGiftPresent = cart.items.find((item) => item.product_id === window.Theme.free_gift.id);
      if(isFreeGiftPresent != undefined && totalItemsInCart === 1){
        console.log("Remove free gift product")
        // Remove free gift product
        let tempObject = {};
        tempObject[isFreeGiftPresent.key] = 0;
        let updateFormData = { updates: tempObject };
        fetch(`${window.Shopify.routes.root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', }, body: JSON.stringify(updateFormData) })
        .then(response => (Promise.all([response, fetch(`${window.Shopify.routes.root}cart.js`, { method: 'GET' })])))
        .then(([res1, res2]) => Promise.all([res1.json(), res2.json()]))
        .then(([response1, cart]) => {
          if (response1.status) {
            console.error("Product cannot be added", response1);
            return;
          }
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
      }
    }

    if(window.location.pathname === '/cart'){
      freeGiftCheckOnCartPage();
    }
  }
  initFreeGift();

  window.addEventListener("custom-cart:updated", function () {
    initFreeGift();
  })
})();